<template>
  <div
    id="section-awards"
    class="container py-14 text-slate md:pb-28 md:pt-[272px]"
  >
    <div
      v-if="data.title"
      class="title mb-10 bg-gradient-to-b from-[#432A9E] to-[#2050A7] bg-clip-text text-center text-xl uppercase leading-none text-transparent md:mb-[80px] md:text-5xl lg:whitespace-pre-line"
      v-html="data.title"
    ></div>

    <div v-if="data.ratings" class="flex flex-col items-center">
      <div
        v-if="data.ratings.title"
        class="title mb-2 text-lg uppercase text-slate md:mb-4 md:text-3xl"
        v-html="data.ratings.title"
      />

      <div
        class="ratings mb-2 h-[32px] w-[192px] bg-contain bg-center bg-no-repeat md:mb-4"
      ></div>

      <div
        v-if="data.ratings.text"
        class="mb-8 text-sm leading-[1.225rem] md:text-md md:leading-[1.8rem]"
        v-html="data.ratings.text"
      />
    </div>

    <div v-if="data.awards && data.awards.length" class="flex justify-center">
      <div
        class="grid grid-cols-2 flex-wrap justify-center gap-x-4 gap-y-6 md:inline-flex md:gap-x-6 md:gap-y-12"
      >
        <div
          v-for="(awards, i) in data.awards"
          :key="i"
          class="group relative flex flex-shrink-0 flex-col items-center gap-y-4 text-center transition-all duration-300 md:top-0 md:w-[154px] md:hover:-top-2"
        >
          <div
            v-if="awards.image"
            v-lazy-background="getAssetUrl(awards.image)"
            class="mx-auto mb-1 h-[70px] w-[56px] bg-contain bg-center bg-no-repeat md:h-[104px] md:w-[71px]"
          ></div>

          <div
            v-if="awards.text"
            class="text-center text-[0.75rem] leading-[0.998rem] transition-all duration-300 md:absolute md:top-full md:h-[60px] md:text-sm md:leading-[1.225rem] md:opacity-0 md:group-hover:opacity-100"
            v-html="awards.text"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMediaAsset } from '~/composables';

interface Props {
  data?: any;
}

withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { getAssetUrl } = useMediaAsset();
</script>

<style lang="sass" scoped>
.ratings
  background-image: url('/images/ratings-stars.png')
</style>
